module.exports = __webpack_public_path__ + "media/images/emblems/Luterbach-blason-258ced614e3f4682040fc203ab93aa7c.png";